module.exports = __webpack_public_path__ + "static/img/appearance.2824abac.png";